export function getGenders() {
    return [
        { id: "M", name: "M" },
        { id: "F", name: "F" }
    ];
};
